// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Add portfolio',
    add_sub_portfolio: 'Add sub-portfolio',
    copy_custom_fields_label: 'Copy custom fields from the parent portfolio',
    delete_portfolio_title: 'Delete portfolio \"{0}\"?',
    DeletionIsUsedDisabled: 'Status cannot be deleted since there is a portfolio with this status.',
    Editor: 'Portfolio editor',
    Manager: 'Portfolio manager',
    members: '1#{0} portfolio member#{0} portfolio members',
    new_portfolio: 'New portfolio',
    NewStatusTitle: 'Add status',
    ParentPortfolio: 'Parent portfolio',
    permissions_title: 'This access level has the following permissions with regard to the portfolio and projects in it',
    Portfolios: 'Portfolios',
    role_for_this_portfolio: 'Access level for this portfolio:',
    Statuses: 'Statuses',
    Teamer: 'Portfolio participant',
    Viewer: 'Portfolio viewer',
};
